import React, { useContext, useEffect, useState } from 'react';
import { newRegistrationContext } from '../../NewRegistrationContext';
import axios from 'axios';

interface IDealerContext {
    isSearchDone: boolean
    isSearching: boolean
    search: ISearch
    dealers: IDealer[]
    selectedDealer?: IDealer

    updateSearch: (newSearch: ISearch) => void
    chooseDealer: (dealer?: IDealer) => void
    searchDealers: () => Promise<void>
}

interface IDealer {
    id: string
    name: string
    address: string
    city: string
    state: string
    country: string
    url: string
    shipToCountries: string[]
    plainAddress: string
}

interface ISearch {
    storeTypeSearch: "retail" | "online"
    countryCode: string
    state: string
    name: string
    city: string
}

export let dealerContext = React.createContext({} as IDealerContext);

let { Provider } = dealerContext;

let DealerProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    let service = useContext(newRegistrationContext);

    let [isSearching, setSearching] = useState(false);
    let [isSearchDone, setSearchDone] = useState(false);

    let [dealers, setDealers] = useState<IDealer[]>([]);
    let [selectedDealer, setSelectedDealer] = useState<IDealer>();
    let [search, setSearch] = useState<ISearch>({
        storeTypeSearch: "retail",
        countryCode: '',
        state: '',
        name: '',
        city: ''
    });

    useEffect(() => {
        if (service.registration.dealerCountryCode)
            setSearch({
                ...search,
                countryCode: service.registration.dealerCountryCode
            })
    }, [service.registration.dealerCountryCode])

    let updateSearch = (newSearch: ISearch) => {
        setSearch(newSearch);
    }

    let searchDealers = async () => {
        try {
            setSearching(true);
            setSearchDone(false);

            chooseDealer(undefined)

            let res = await axios.get('/api/Dealer/GetDealer', { params: { ...search } });
            if (res.data && res.data.length > 0)
                setDealers(res.data);

            setSearchDone(true);

        } catch (err) { }
        finally {
            setSearching(false);
        }
    }

    let chooseDealer = (dealer?: IDealer) => {
        setSelectedDealer(dealer);

        service.updateRegistration({
            ...service.registration,
            dealerAddress: dealer?.address || '',
            dealerCountryCode: dealer?.country || '',
            dealerId: dealer?.id || '',
            dealerName: dealer?.name || ''
        })
    }


    return (
        <Provider
            value={{
                isSearching,
                isSearchDone,
                search,
                dealers,
                selectedDealer,

                chooseDealer,
                updateSearch,
                searchDealers
            }}
        >
            {children}
        </Provider>
    )
}

export default DealerProvider;